import React, { memo } from 'react'

import { string } from 'prop-types'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'

function Keywords({ keywords = '' }) {
  return (
    <div className="search-subscription__keywords">
      {keywords}
    </div>
  )
}

Keywords.propTypes = {
  keywords: string,
}

const mapStateToProps = ({
  pageCategory,
  selectedFilters: {
    keywords,
  }
}) => ({
  keywords: keywords || pageCategory || '',
})

export default WithListingPageContext(mapStateToProps)(memo(Keywords))
